import { IStructEnpoints } from '@shared/interfaces/endpoints/Istruct-enpoints';

export const points: IStructEnpoints = {
  schema_api: {
    certify: [
      {
        cbconf: [
          {
            controller: 'UrbanAreas',
            points: [
              {
                GetUrbanArea: '',
                AreaActions: '',
              },
            ],
          },
          {
            controller: 'Regions',
            points: [
              {
                GetAllRegions: '',
                GetRegionsByArea: 'byarea',
                RegionActions: '',
                UpdateRegionsByTeamMember: 'teamMember',
              },
            ],
          },
          {
            controller: 'plants',
            points: [
              {
                GetAllPlants: '',
                GetPlantsByRegion: 'byregion',
                RegionBindPlants: '',
                RegionMgrInitialLoad: 'initialLoad',
                PlantRelocation: 'relocation',
                CurrentPlants: 'currentPlants',
              },
            ],
          },
          {
            controller: 'Parameters',
            points: [
              {
                ParamsbyCountry: 'byCountry',
                ParamsbyPlant: 'byPlant',
                GeneralCatalog: 'genCatalog',
                GCInitialLoad: 'InitialLoad',
              },
            ],
          },
          {
            controller: 'ApplicationLogs',
            points: [
              {
                GetAllNotifications: 'notifications',
                GetTypeNotifications: 'notifications/types',
                GetAllEmailReceptors: 'notifications/recipients',
                GetNotificationById: 'notifications',
                SaveNotification: 'notifications',
                SaveRecipients: 'notifications/recipients',
                UpdateNotification: 'notifications',
                UpdateNotificationPlantsRecipients: 'notifications',
                UpdateRecipients: 'notifications/recipients',
                DeleteNotification: 'notifications',
                DeleteNotificationRecipient: 'notifications',
                DeleteNotificationPlant: 'notifications',
                DeleteRecipient: 'notifications/recipients',
              },
            ],
          },
        ],
        cmfram: [],
        cprod: [
          {
            controller: 'Products',
            points: [
              {
                ProductCatalog: 'ProductElements',
                PREInitialLoad: 'InitialLoad',
                getAppicationGrups: 'getAppicationGrups',
              },
            ],
          },
          {
            controller: 'TechnicalProduct',
            points: [
              {
                GetTechnicalProducts: 'byPlantCode',
              },
            ],
          },
          {
            controller: 'CommercialProducts',
            points: [
              {
                GetAllCommercialProducts: '',
                GetCommercialProductsByPlant: 'byplants',
                GetCommercialProductSubmittal: 'submittal',
                UpdateProductSpecialization: 'specialization',
              },
            ],
          },
        ],
        cqa: [
          {
            controller: 'Laboratory',
            points: [
              {
                LaboratoriesCatalogs: 'initialLoad',
                GetLaboratories: '',
                GetLaboratoriesByRegion: 'region',
                GetTechnicians: 'technicians',
              },
            ],
          },
          {
            controller: 'TestCharacteristics',
            points: [
              {
                GetInitialLoad: 'groupbyclass',
                ConfigInitialCatalogs: 'initialLoad',
                TestCatalog: '',
                TCDownload: 'export',
                TCUpload: 'import',
              },
            ],
          },
          {
            controller: 'TestSpecifications',
            points: [
              {
                TestSpecificationsCatalogs: 'initialLoad',
                TestSpecificationsInfo: '',
                TestSpecificationsCopy: 'copy',
              },
            ],
          },
          {
            controller: 'Reports',
            points: [
              {
                GetTestResultReport: 'testResult',
                GetSamplingFrecuency: 'samplingFrequency',
                GetSingleSampleReport: 'singleSampleTest',
              },
            ],
          },
          {
            controller: 'SamplingFrequencyConfigurations',
            points: [
              {
                FrecuencyTable: '',
              },
            ],
          },
          {
            controller: 'Sample',
            points: [
              {
                GetSamplehistory: 'history',
                GetSampleInitialLoad: 'initialLoad',
                SaveSample: '',
                GetSample: '',
                GetAvailableTests: 'availableTests',
                SaveSampleTests: 'sampleTests',
                SaveSampleTestDetail: 'sampleTestDetail',
                UpdateSample: '',
                UpdateSampleTests: 'sampleTestDetail',
                DeleteSample: '',
                DeleteSampleTest: 'sampleTests',
                GetSampleReportDocuments: '',
              },
            ],
          },
          {
            controller: 'Ticket',
            points: [
              {
                GetTickets: 'tickets',
              },
            ],
          },
          {
            controller: 'Customer',
            points: [
              {
                GetCustomers: 'jobsites',
              },
            ],
          },
          {
            controller: 'Reports/mixDesign',
            points: [
              {
                MixDesignCatalogs: 'initialLoad',
                GetMixDesign: '',
              },
            ],
          },
          {
            controller: 'Customer/jobSites',
            points: [
              {
                GetAllCustomerJobsites: '',
              },
            ],
          },
          {
            controller: 'Resultentry/testschedule',
            points: [
              {
                TestScheduleCatalogs: 'initialLoad',
                GetTestSchedule: '',
              },
            ],
          },
          {
            controller: 'TestSchedule',
            points: [
              {
                TSCatalogs: 'initialLoad',
                GetTS: '',
              },
            ],
          },
          {
            controller: 'Reports/TestSchedule',
            points: [
              {
                GetTsReport: '',
              },
            ],
          },
          {
            controller: 'PdfResultImport',
            points: [
              {
                PDFImportCatalogs: 'initialLoad',
                PDFDocuments: 'getDocuments',
                PDFSampleDetail: 'getPdfResultImportDetail',
                ImportPDF: 'ImportPdf',
                SimplePdfResultImport: '',
                getTicketsByGuid: 'getImportedPdfStatus',
              },
            ],
          },
          {
            controller: 'Specimen',
            points: [
              {
                Specimen: '',
                SpecimenInitialLoad: 'InitialLoad',
              },
            ],
          },
        ],
        cqaimp: [],
        crawma: [
          {
            controller: 'BatchAlert',
            points: [
              {
                AlertsCatalogs: 'initialLoad',
                GetAlerts: 'Alert',
                GetSimpleAlerts: '',
                GetContacts: 'contacts',
              },
            ],
          },
          {
            controller: 'RawMaterialCatalog',
            points: [
              {
                RMTInitialLoad: 'translation/InitialLoad',
                RMTTranslation: 'translation',
                RMTUsageKey: 'usageKey',
                RMTSubtypes: 'subtypes',
                RMTCatalogue: 'catalogue',
                RMTCatalogueInit: 'catalogue/InitialLoad',
                RMTCatalogueDetail: 'catalogue/detail',
                RMTCataloguePlants: 'catalogue/plants',
                RMTCatalogueUpload: 'catalogue/import',
                RMTCatalogueDownload: 'catalogue/export',
                RMTCatalogueCopy: 'catalogue/copyMaterials',
                RMTCatalogueResend: 'catalogue/resend',
                RMTCatalogueRecipe: 'recipe/byplant',
                RMTCatalogueMaterialsRecipe: 'recipe/materialsByRecipe',
                RMTCatalogueMaterialsByPlant: 'recipe/materials',
                RMTCatalogueGradingSieve: 'recipe/gradingsieve',
                RMTCatalogueMaterialsToSubstitution: 'recipe/materialsToSubstitution',
              },
            ],
          },
          {
            controller: 'ValueAdded',
            points: [
              {
                VAMInitialLoad: 'initialLoad',
                VAMSideData: 'management',
                VAMDetail: 'detail',
                VAMDetailNac: 'notAllowedCombination',
                VAMAppGroup: 'appGroupByFamily',
                VAMAllocation: 'allocation',
                VAMLog: 'logs',
                VAMResend: 'resend',
                VAMDownload: 'download',
                VAMSusGrid: 'substitution',
                VAMSusInitialLoad: 'substitution/initialLoad',
                VAMSusFamilies: 'substitution/families',
                VAMSusMaterialsByFamily: 'substitution/materialsByFamily',
                VAMSusConfigMaterials: 'substitution/configMaterials',
              },
            ],
          },
        ],
        crecip: [
          {
            controller: 'EpdLog',
            points: [
              {
                EpdInitialLoad: 'initialLoad',
                DataTableEpd: 'GetEpdCertificate',
                CreateNewEpd: 'CreateNewEpd',
              },
            ],
          },
          {
            controller: 'Recipe',
            points: [
              {
                recipe: '',
                recipeUpdate: 'manual/formulate',
                rpInitialLoad: 'initialLoad',
                rpSideData: 'sideBar',
                rpDetailData: 'detail',
                rpDownload: 'export',
                rpUpload: 'import',
                internalComments: 'internalComment',
                rpExtend: 'extend',
                rpLog: 'logs',
                rpLogActive: 'log/activate',
                getHayStackSieveDetail: 'hayStackSieveDetail',
                getHayStackCurves: 'stackCurvesByAggregates',
                subsSubstitute: 'substitution/substitute',
                subsAdjustAggregatesOrFines: 'substitution/adjustAggregatesOrFines',
                subsSave: 'substitution/save',
                RecipeResend: 'resend',
                rpDetailForBulkUpdate: 'detailForBulkUpdate',
                rpUpdateBulk: 'updateheader',
                rpSubstitutionProgress: 'substitution/status',
                rpChangeLogDetail: 'log/preview',
              },
            ],
          },
          {
            controller: 'Submittal',
            points: [
              {
                GetSubmitalLog: 'submitalLogs',
                GetSubmitalFilters: 'search',
                GetSubmittalById: '',
                GetSubmitalInitialLoad: 'initialLoad',
                GetSubmitalDocsBySubCategory: 'documents',
                GetSubmittalNewMix: 'getNewMix',
                GetSubmittalSampleResults: 'sampleResults',
                SaveSubmittalDocsBySubCategory: 'documents',
                CreateSubmittalDocumentData: 'documents',
                UpdateSubmittalDocumentData: 'documents',
                GetSubmittalDocumentsManager: 'documents',
                UpdateSubmittalDocument: 'documents',
                DeleteSubmittalDocuments: 'documents',
                SaveUpdateDisclaimer: 'disclaimer',
                SaveSubmittalDraft: '',
                DeleteSubmittal: '',
                ReportSubmittal: 'report',
                GetReportSubmittals: 'massiveReport',
              },
            ],
          },
        ],
        repm: [
          {
            controller: 'kpi/concrete-volume',
            points: [
              {
                GetInitialLoadDashboard: 'initialLoad',
                GetTopProductsByPlants: 'top15',
                GetTopProductsByPlantsExport: 'top15/export',
                GetOutOfToleranceSlumpAir: 'outOfTolerance',
                GetOutOfToleranceSlumpAirExport: 'outOfTolerance/export',
              },
            ],
          },
          {
            controller: 'kpi/quality-dashboard',
            points: [
              {
                GetTwentyEightDayBreaks: 'plantBreaks28day',
                GetTwentyEightDayBreaksExport: 'plantBreaks28day/export',
              },
            ],
          },
        ],
      },
    ],
    RMX: [
      {
        cum: [
          {
            controller: 'arkik-controller',
            points: [
              {
                GetPlantsByCompany: 'v1/cum/plants',
              },
            ],
          },
        ],
      },
    ],
  },
};
